var map = {
	"./feature-1.png": 48140,
	"./feature-2.png": 15175,
	"./feature-3.png": 23038,
	"./feature-4.png": 67601,
	"./feature-5.png": 35560,
	"./feature-6.png": 97539,
	"./feature-7.png": 7706,
	"./feature-8.png": 60589,
	"./feature-news-1.jpg": 73194,
	"./feature-news-2.jpg": 24181,
	"./feature-news-3.jpg": 33272
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50240;